(function () {
  function init() {
    var wraps = document.querySelectorAll('.ymm-hero .ymm-select');
    if (!wraps.length) return;
    var sec = wraps[0].closest('.shopify-section');
    var all = [];

    function closeAll(except) { all.forEach(function (d) { if (d !== except) d.close(); }); }

    Array.prototype.forEach.call(wraps, function (w) {
      var sel = w.querySelector('select');
      if (!sel || w.dataset.cmpDd) return;
      w.dataset.cmpDd = '1';
      w.classList.add('cmp-dd-on');
      sel.tabIndex = -1;
      sel.setAttribute('aria-hidden', 'true');

      var dd = document.createElement('div'); dd.className = 'cmp-dd';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'cmp-dd__btn';
      btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
      var lab = document.createElement('span'); lab.className = 'cmp-dd__label'; lab.id = (sel.id || 'dd') + '-val';
      btn.appendChild(lab);
      btn.insertAdjacentHTML('beforeend', '<svg class="cmp-dd__chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>');
      var ul = document.createElement('ul'); ul.className = 'cmp-dd__list'; ul.setAttribute('role', 'listbox'); ul.id = (sel.id || 'dd') + '-list';
      btn.setAttribute('aria-controls', ul.id);
      dd.appendChild(btn); dd.appendChild(ul); w.appendChild(dd);

      var label = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
      if (label) {
        label.id = label.id || (sel.id + '-lbl');
        btn.setAttribute('aria-labelledby', label.id + ' ' + lab.id);
        label.addEventListener('click', function (e) { e.preventDefault(); if (!btn.disabled) btn.focus(); });
      }

      var active = -1, buf = '', bufT = null;

      function mark(scroll) {
        var items = ul.children;
        for (var i = 0; i < items.length; i++) items[i].classList.toggle('is-active', i === active);
        if (scroll && items[active]) items[active].scrollIntoView({ block: 'nearest' });
      }
      function build() {
        ul.innerHTML = '';
        Array.prototype.forEach.call(sel.options, function (o, i) {
          var li = document.createElement('li');
          li.className = 'cmp-dd__opt' + (o.value === '' ? ' cmp-dd__opt--ph' : '');
          li.setAttribute('role', 'option'); li.dataset.i = i; li.textContent = o.textContent;
          if (i === sel.selectedIndex) li.setAttribute('aria-selected', 'true');
          ul.appendChild(li);
        });
        var cur = sel.options[sel.selectedIndex];
        lab.textContent = cur ? cur.textContent : '';
        lab.classList.toggle('is-placeholder', !cur || cur.value === '');
        w.classList.toggle('is-disabled', sel.disabled);
        btn.disabled = sel.disabled;
        if (sel.disabled) close();
      }
      function open() {
        if (sel.disabled || w.classList.contains('is-open')) return;
        closeAll(api);
        w.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
        if (sec) { sec.style.position = 'relative'; sec.style.zIndex = '40'; }
        active = Math.max(0, sel.selectedIndex); mark(true);
      }
      function close() {
        if (!w.classList.contains('is-open')) return;
        w.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
        if (sec && !document.querySelector('.ymm-select.is-open')) { sec.style.zIndex = ''; sec.style.position = ''; }
      }
      function choose(i) {
        if (i < 0 || i >= sel.options.length) return;
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        build(); close(); btn.focus();
      }

      btn.addEventListener('click', function () { w.classList.contains('is-open') ? close() : open(); });
      ul.addEventListener('mousedown', function (e) { e.preventDefault(); });
      ul.addEventListener('click', function (e) { var li = e.target.closest('li'); if (li) choose(+li.dataset.i); });
      ul.addEventListener('mousemove', function (e) { var li = e.target.closest('li'); if (li && +li.dataset.i !== active) { active = +li.dataset.i; mark(false); } });
      btn.addEventListener('keydown', function (e) {
        var isOpen = w.classList.contains('is-open'), n = sel.options.length;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (!isOpen) { open(); return; }
          active = Math.min(n - 1, Math.max(0, active + (e.key === 'ArrowDown' ? 1 : -1))); mark(true);
        } else if (e.key === 'Home' || e.key === 'End') {
          if (isOpen) { e.preventDefault(); active = e.key === 'Home' ? 0 : n - 1; mark(true); }
        } else if (e.key === 'Enter' || e.key === ' ') {
          if (isOpen) { e.preventDefault(); choose(active); } else { e.preventDefault(); open(); }
        } else if (e.key === 'Escape') {
          if (isOpen) { e.preventDefault(); close(); }
        } else if (e.key === 'Tab') {
          close();
        } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
          buf += e.key.toLowerCase(); clearTimeout(bufT); bufT = setTimeout(function () { buf = ''; }, 600);
          for (var k = 0; k < n; k++) {
            var idx = (Math.max(0, active) + (buf.length === 1 ? 1 : 0) + k) % n;
            if (sel.options[idx].textContent.toLowerCase().indexOf(buf) === 0) { if (!isOpen) open(); active = idx; mark(true); break; }
          }
        }
      });

      new MutationObserver(build).observe(sel, { childList: true, attributes: true, attributeFilter: ['disabled'] });
      sel.addEventListener('change', build);
      var api = { close: close, build: build };
      all.push(api);
      build();
    });

    document.addEventListener('mousedown', function (e) { if (!e.target.closest('.ymm-select')) closeAll(); });
    var reset = document.getElementById('ymm-reset');
    if (reset) reset.addEventListener('click', function () { setTimeout(function () { all.forEach(function (d) { d.build(); }); }, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
